module.exports = __webpack_public_path__ + "img/cer_am.5ee94b96.jpg";